// extracted by mini-css-extract-plugin
module.exports = {"sideBody":"jut__SideBody__sideBody"};